module.exports = __webpack_public_path__ + "static/building-b22c2ced543c811d408a8a42f66dbd5d.jpg";